define([
    "knockout",
    "globals",
    "jquery"
  ],
  function(ko, globals, $) {

    ko.bindingHandlers.visualizerImage = {
      update: function(element, valueAccessor, allBindings, viewModel, bindingContext) {

        var blankImagePath = "/Content/Images/visualizer-blank.png";

        var preloadBlank = new Image();
        preloadBlank.src = blankImagePath;

        element.onerror = function() {
          element.src = globals.visualizationUnavailableImage;
          $(element).data("visualizerZoom", "false");
          hideRollOver();
        };

        element.onload = function() {
          var elementRelativePath = element.src.replace(/^(?:\/\/|[^\/]+)*\//, "/");
          if (elementRelativePath !== blankImagePath && elementRelativePath !== globals.visualizationUnavailableImage) {
            showRollOver();
          } else {
            hideRollOver();
          }
        };

        if (bindingContext.$data.anyVisualizableOptions()) {
          if (ko.unwrap(valueAccessor()) === undefined || ko.unwrap(valueAccessor()) === blankImagePath) {
            if (bindingContext.$parent && bindingContext.$parent.shouldShowImage()) {
              element.src = blankImagePath;
              bindingContext.$data.shouldShowVisualizer(true);
            } else if (bindingContext.$parent) {
              bindingContext.$data.shouldShowVisualizer(true);
            } else {
              bindingContext.$data.shouldShowVisualizer(false);
            }
            $(element).data("visualizerZoom", "false");
          } else {
            element.src = ko.unwrap(valueAccessor());
            if (bindingContext.$data.anyVisualizableOptions()) {
              bindingContext.$data.shouldShowVisualizer(true);
              $(element).data("visualizerZoom", "true");
            }
          }
        }

        function showRollOver() {
          if (!globals.isIOS) {
            $(".bdc-visualizer-roll-over").show();
          }
        }

        function hideRollOver() {
          $(".bdc-visualizer-roll-over").hide();
        }
      }
    };
  });
